export default "__VITE_ASSET__DQNDFvQu__"